import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageShell } from '../components/page/PageShell'
import {
  acceptAnalytics,
  emitConsentChange,
  getConsent,
  rejectAnalytics,
} from '../consent'
import '../components/ConsentBanner.css'

export default function PrivacyPage() {
  const [consent, setConsent] = useState(null)

  useEffect(() => {
    const sync = () => setConsent(getConsent())
    sync()
    window.addEventListener('st:consent', sync)
    return () => window.removeEventListener('st:consent', sync)
  }, [])

  const onAccept = () => {
    acceptAnalytics()
    emitConsentChange()
  }

  const onReject = () => {
    rejectAnalytics()
    emitConsentChange()
  }

  const statusLabel =
    consent === 'analytics'
      ? 'Du har accepteret statistik-cookies.'
      : consent === 'necessary'
        ? 'Du har afvist statistik-cookies (kun nødvendige).'
        : 'Du har endnu ikke set eller besvaret cookie-valget.'

  return (
    <PageShell
      title="Privatliv"
      intro="Sådan behandler Sportsteknologi.dk data, når du bruger sitet."
      breadcrumbs={[{ to: '/privatliv', label: 'Privatliv' }]}
    >
      <div className="site-prose" style={{ maxWidth: '40rem' }}>
        <p>{statusLabel}</p>
        <p style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginTop: '0.75rem' }}>
          <button type="button" className="consent-btn consent-btn--accept" onClick={onAccept}>
            Accepter statistik
          </button>
          <button type="button" className="consent-btn consent-btn--reject" onClick={onReject}
            style={{ color: '#1a202c', borderColor: '#a0aec0' }}>
            Kun nødvendige
          </button>
        </p>

        <h2>Cookies</h2>
        <ul>
          <li>
            <strong>st_consent</strong> (nødvendig efter dit valg) — husker om du har
            accepteret eller afvist statistik. Gemmes i op til 180 dage.
          </li>
          <li>
            <strong>st_vid</strong> (statistik, kun efter accept) — et tilfældigt
            besøgs-id, så vi kan se tilbagevendende besøg. Gemmes i op til 1 år.
            Slettes hvis du afviser.
          </li>
        </ul>

        <h2>Besøgsstatistik</h2>
        <p>
          Statistik kører kun, hvis du trykker “Accepter statistik”. Vi gemmer da på
          vores egen server:
        </p>
        <ul>
          <li>sidens sti (fx <code>/bat</code>)</li>
          <li>eventuel ekstern henvisende hjemmeside (kun domænenavn)</li>
          <li>dit <code>st_vid</code> (ikke navn, e-mail eller login)</li>
        </ul>
        <p>
          Vi gemmer ikke din IP-adresse i klartekst. Der er ingen tredjeparts-cookies
          (ingen Google Analytics e.l.).
        </p>

        <h2>Tekniske logs</h2>
        <p>
          Webserveren gemmer almindelige access-logs i en begrænset periode for drift
          og sikkerhed (fx at afvise angreb). De bruges ikke til markedsføring og
          kræver ikke cookie-samtykke.
        </p>

        <h2>Kontakt</h2>
        <p>
          Spørgsmål om privatliv: brug kontaktoplysningerne på{' '}
          <Link to="/">forsiden</Link>, eller skriv til ejeren af domænet
          sportsteknologi.dk.
        </p>
      </div>
    </PageShell>
  )
}
